// config/config.js
module.exports = {
  // baseURL: "http://localhost:7001/api",
  baseURL: "https://api.astrodata.app/api",
};
